// Utility functions for document number generation & validation

/**
 * Allowed prefixes for document numbers.
 */
export const DOCUMENT_PREFIXES = [
  'ECB',
  'ECR',
  'ECE',
  'ECP',
  'ECG',
  'ECQ',
  'ECZ'
] as const;

/**
 * Regular expression to validate document numbers in the format:
 * PREFIX-YYYY-CompanyNumber#########
 */
export const DOCUMENT_NUMBER_REGEX = new RegExp(
  `^(?:${DOCUMENT_PREFIXES.join('|')})-\\d{4}-[A-Za-z0-9]+\\d{7}$`
);

/**
 * Validate that a document number matches the required pattern.
 *
 * @param docNumber - Document number to validate
 * @returns `true` if valid, `false` otherwise
 */
export function isValidDocumentNumber(docNumber: string): boolean {
  return DOCUMENT_NUMBER_REGEX.test(docNumber);
}

/**
 * Optional helper to generate a document number given components. The caller is
 * responsible for providing a zero-padded sequence.
 */
export function generateDocumentNumber(
  prefix: typeof DOCUMENT_PREFIXES[number],
  year: number,
  companyNumber: string | number,
  sequence: string | number
): string {
  return `${prefix}-${year}-${companyNumber}${sequence}`;
}